import { Component, Input, OnInit } from '@angular/core';
import { Treatment } from '../../../../shared/state/treatment/treatment.model';

@Component({
    selector: 'app-treatment-list',
    templateUrl: './treatment-list.component.html',
    styleUrls: ['./treatment-list.component.scss'],
})
export class TreatmentListComponent implements OnInit {
    @Input() treatments: Treatment[];
    @Input() appDelegate: boolean;
    public treatmentGroups: Array<Treatment[]> = [];
    public treatmentSingle: Treatment[] = [];

    constructor() {}

    ngOnInit(): void {
        this.orderVoucherGroups();
    }

    orderVoucherGroups() {
        this.treatmentSingle = this.treatments.filter(e => !e.voucherGroupId);
        const vouchersWithGID = this.treatments.filter(e => e.voucherGroupId);
        
        if (vouchersWithGID.length > 0) {
            vouchersWithGID.forEach( (e) => {
                if ( this.treatmentGroups[e.voucherGroupId] === undefined ) {
                    this.treatmentGroups[e.voucherGroupId] = [];
                }
                this.treatmentGroups[e.voucherGroupId].push(e);
            
            });
            this.treatmentGroups = this.treatmentGroups.filter( e => e);
        };
    }
}
